import { StyledLogo } from "./style";

const AsideLogo = () => {
    return (
        <StyledLogo className="aside-logo" path="/">
            do<span>ar</span>
        </StyledLogo>
    );
};

export default AsideLogo;
